import { render, staticRenderFns } from "./ManagementPurchasesRefund.vue?vue&type=template&id=4dcc3256&scoped=true"
import script from "./ManagementPurchasesRefund.vue?vue&type=script&lang=js"
export * from "./ManagementPurchasesRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc3256",
  null
  
)

export default component.exports